<template>
    <v-layout row wrap>
    <v-flex md6 offset-md3>
        <div class="main-content-wrapper results">
            <div class="main-content">
                <v-icon class="results-main-icon" color="green">check_circle_outline</v-icon>
                <h1 class="heading">Thank you for your purchase</h1>
                <p>Your insurance documents and tax invoice<br />will be emailed to you shortly.</p>
                <p>For more information, you may call us at<br />1800 658 699.</p>
            </div>
        </div>
    </v-flex>
    </v-layout>
</template>

<script>
export default {
    name: "PurchaseResult",
    created() {
        localStorage.removeItem("session_id")
    },
}
</script>

<style lang="scss" scoped>

.main-content-wrapper {
    display: flex;
    align-items: center;
    height: 100%;
    
    .results-main-icon {
        font-size: 120px;
        margin-bottom: 80px
    }

    .main-content {
        text-align: center;
        flex: 0 0 100%;
        height: min-content;
        font-size: 18pt;
        line-height: 18px;
        .heading {
            font-weight: 600;
            font-size: 48px;
            line-height: 48px;
            margin-bottom: 24px;
        }
    }
}

.main-content-wrapper.results {
    .main-content {
        padding: 34px 0;
    }
    .results-main-icon {
        margin-bottom: 20px;
    }
}
</style>